import type { SvgIconProps } from '@backoffice-frontend/patterns'

export const DoorIcon = (props: SvgIconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        d="M6 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H6H5C3.89543 3 3 3.89543 3 5V8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M3.00336 14.501L11 14.5M3 14.501L5.50104 12M5.50104 17.001L3 14.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 10L20 10"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
)
